import {Controller} from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
    submit() {
        let parentDiv = this.element.parentElement
        let targetItem = this.element.querySelector(this.element.dataset.target)
        if (targetItem != undefined) {
            parentDiv.querySelector('.hidden-search-box').value = targetItem.value
            this.addRemoveClass(parentDiv.querySelectorAll('.pagination-numbers'), 'is-hidden', targetItem.value.length === 0)
        }
        setTimeout(() => {
            Rails.fire(this.element, "submit");
        }, 1000)
    }

    changeValue() {

    }

    addRemoveClass(elements, className, remove = false) {
        if (elements.length > 0) {
            elements.forEach((element) => {
                if (remove) {
                    element.classList.remove(className)
                } else {
                    element.classList.add(className)
                }
            });
        }
    }
}
